/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import CommonInput from "../Inputs/CommonInput";
import JsonCollapse from "../../../Components/JsonCollapse";
import Errors from "../../../Components/Errors";

export default function LogicItemOptions({
  item,
  itemType = "item",
  title,
  config,
  isOpen,
  optionsPath,
  parentPath,
  setItem,
  errorFilter,
  isConditionInput = false,
  extraContent = null,
  compact = false,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const itemWithDefaultErrorPolicy =
    (itemType === "action" || itemType === "condition") && !item.ErrorPolicy
      ? { ...item, ErrorPolicy: "workflow" }
      : item;
  const errorPolicyInput =
    itemType === "action" || itemType === "condition"
      ? [
          {
            type: "property",
            field: "ErrorPolicy",
            defaultValue: "workflow",
            props: {
              label: "On error",
              inputType: "select",
              isClearable: false,
              isValidNewOption: () => false,
              options: [
                { value: "ignore", label: "Ignore and continue" },
                { value: "fail_fast", label: "Fail fast" },
                { value: "workflow", label: "Use workflow policy" },
                { value: "trigger", label: "Trigger error listener and stop" },
                {
                  value: "trigger_and_continue",
                  label: "Trigger error listener and continue",
                },
              ],
            },
          },
        ]
      : [];
  const errorMessageOverrideInput =
    itemType === "action" || itemType === "condition"
      ? [
          {
            type: "compound",
            field: "errorMessage",
            ifPropertyHas: [
              {
                field: "ErrorPolicy",
                values: ["trigger", "trigger_and_continue"],
              },
            ],
            defaultValue: [""],
            props: {
              label: "Override error message (optional)",
              inputArgumentProps: { Format: "short-text" },
              isValidNewOption: (value) => value.trim(),
            },
          },
        ]
      : [];
  const inputs = [
    ...(config?.inputs || []),
    ...errorPolicyInput,
    ...errorMessageOverrideInput,
  ];
  const hasOptions = inputs.length > 0 || !!extraContent;

  if (!hasOptions) {
    return (
      <span className="btn text-secondary disabled ms-1 border-0">
        No options
      </span>
    );
  }

  return (
    <>
      <Link
        to={optionsPath}
        className={`btn btn-outline-primary ms-1 border-0 ${
          compact ? "btn-sm d-inline-flex align-items-center" : ""
        }`}
        style={compact ? { height: 31 } : undefined}
      >
        {errorFilter && (
          <Errors filterFn={errorFilter} exclamationMarkOnly linkDisabled />
        )}
        <FontAwesomeIcon icon={faCog} className="me-2" />
        Options
      </Link>
      <Offcanvas
        show={isOpen}
        placement="end"
        className={`${itemType}-options-modal`}
        backdropClassName={`${itemType}-options-modal-backdrop`}
        onHide={() => {
          navigate(location.state?.nextPage || parentPath);
        }}
        style={{ width: 800 }}
      >
        <Offcanvas.Header>
          <Offcanvas.Title>
            <FontAwesomeIcon icon={faCog} /> {title}
            {item.UUID && (
              <span className="badge bg-light text-muted border ms-2">
                {item.UUID}
              </span>
            )}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {isOpen &&
            inputs.map((input, index) => (
              <CommonInput
                isConditionInput={isConditionInput}
                className={`mb-5 bg-purple-gradient p-2 rounded-2 ${
                  input.className || ""
                } ${input.group ? "d-inline-block align-top" : ""}`}
                key={`${item.UUID}-${input.field || input.label}-${index}${
                  input.props?.key
                }-${input.props?.keyValue}`}
                input={input}
                condition={itemWithDefaultErrorPolicy}
                setCondition={setItem}
              />
            ))}

          {isOpen && extraContent}

          <JsonCollapse json={item} />
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
